import { useMyMediaUpload } from "../context/MyMediaUploadContext.jsx";

export function MyMediaUploadManager() {
  const {
    imageModal,
    reelModal,
    submittingImages,
    imageInputRef,
    reelInputRef,
    combinedInputRef,
    loadImageFiles,
    rotateImage,
    closeImageModal,
    submitImages,
    uploadReel,
    handleCombinedFiles,
  } = useMyMediaUpload();

  const colClass = (count) => {
    if (count >= 6) return "col-6 col-md-2";
    if (count >= 4) return "col-6 col-md-3";
    if (count >= 3) return "col-6 col-md-4";
    if (count >= 2) return "col-6 col-md-6";
    return "col-12";
  };

  const dialogSize = (count) => {
    if (count >= 6) return "modal-xl";
    if (count >= 4) return "modal-lg";
    return "";
  };

  return (
    <>
      {/* Hidden inputs */}
      <input
        ref={imageInputRef}
        type="file"
        className="d-none"
        accept="image/png, image/jpeg"
        multiple
        onChange={(e) => { loadImageFiles(e.target.files); e.target.value = ""; }}
      />
      <input
        ref={reelInputRef}
        type="file"
        className="d-none"
        accept=".mp4"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) uploadReel(f); e.target.value = ""; }}
      />
      <input
        ref={combinedInputRef}
        type="file"
        className="d-none"
        accept="image/png, image/jpeg, video/mp4"
        multiple
        onChange={(e) => handleCombinedFiles(e.target.files)}
      />

      {/* Image modal */}
      {imageModal.open && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
          <div className="modal fade show d-block" tabIndex={-1} style={{ zIndex: 1050 }} aria-modal="true" role="dialog">
            <div className={`modal-dialog modal-dialog-centered ${dialogSize(imageModal.files.length)}`}>
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => closeImageModal(true)}
                    disabled={submittingImages}
                  />
                </div>

                <div className="modal-body">
                  <div className="row g-2">
                    {imageModal.files.map((item, idx) => (
                      <div key={idx} className={colClass(imageModal.files.length)}>
                        <div className="card h-100 bg-transparent border-0">
                          <div className="p-2 border rounded-top-4">
                            <div style={{
                              backgroundImage: `url(${item.dataUrl})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              transform: `rotate(${item.angle}deg)`,
                              width: "100%",
                              paddingBottom: "100%",
                              transition: "transform 0.3s ease",
                              borderRadius: "0.5rem",
                            }} />
                          </div>
                          <div className="card-footer border rounded-bottom-4 border-top-0 bg-transparent py-2 text-end">
                            <button
                              type="button"
                              className="btn btn-sm"
                              onClick={() => rotateImage(idx)}
                              title="Rotate 90°"
                              disabled={submittingImages}
                            >
                              {item.angle > 0 && <span className="me-1 small">{item.angle}°</span>}
                              <i className="fi fi-rr-rotate-right" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => closeImageModal(true)}
                    disabled={submittingImages}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => submitImages(imageModal.files)}
                    disabled={submittingImages}
                  >
                    {submittingImages ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        Uploading…
                      </>
                    ) : "Continue"}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}

      {/* Reel modal */}
      {reelModal.open && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
          <div className="modal fade show d-block" tabIndex={-1} style={{ zIndex: 1050 }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Uploading reel</h5>
                </div>

                <div className="modal-body">
                  <div className="progress mb-3">
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      aria-valuenow={reelModal.progress}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: `${reelModal.progress}%`, transition: "width 0.4s ease" }}
                    />
                  </div>
                  <p className="text-center text-muted small mb-0">
                    {reelModal.progress < 90 ? `Uploading… ${Math.round(reelModal.progress)}%` : "Processing video…"}
                  </p>
                </div>

              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export function UploadButton({ type = "combined", prompt = "0", onUploaded, label, className = "btn btn-primary", icon, ...rest }) {
  const { openUpload } = useMyMediaUpload();

  const defaultLabel = { image: "Upload Image", reel: "Upload Video", combined: "Upload" }[type];

  return (
    <button type="button" className={className} onClick={() => openUpload({ type, prompt, onUploaded })} {...rest}>
      {icon && <span className="me-2">{icon}</span>}
      {label ?? defaultLabel}
    </button>
  );
}